import { type ComponentProps, type FC, type ReactNode } from 'react';

import clsx from 'clsx';

import { type WithClassName } from '@/types/react';

import styles from './CornerBorders.module.scss';

type CornerBordersProps = WithClassName &
  Omit<ComponentProps<'div'>, 'className'> & {
    children: ReactNode;
    isActive?: boolean;
  };

export const CornerBorders: FC<CornerBordersProps> = (props) => {
  const { className, children, isActive, ...rest } = props;

  return (
    <div className={clsx(styles.root, isActive && styles.isActive, className)} {...rest}>
      {children}
    </div>
  );
};
